import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'resource#title_graffito',
  type: 'graffito',
  tabs: 'graffito',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'editor_metadata',
        type: 'metadata',
      },
      {
        id: 'image-viewer-iiif',
        type: 'viewer-iiif',
        title: 'resource#image-viewer-iiif',
        options: {
          libOptions: {
            window: {
              sideBarOpenByDefault: false,
              allowClose: false,
              allowMaximize: true,
              defaultSideBarPanel: 'info',
              views: [
                { key: 'single' },
                { key: 'gallery' },
              ],
              workspaceControlPanel: {
                enabled: false,
              },
            },
            id: 'mirador-container',
          },
        }
      },
      {
        id: 'text-viewer-graffito_text',
        type: 'text-viewer',
        options: {
          searchId: 'xml_text',
        },
      },
      {
        id: 'tab-bar',
        type: 'tabs',
      },
    ],
    content: [
      {
        id: 'metadata-graffito_text',
        type: 'metadata',
        // title: 'resource#metadata_graffito_text',
      },
      // collegamenti agli indici, sotto la sezione testo
      {
        id: 'collection-graffito_text_persone',
        type: 'collection',
        title: 'resource#collection_graffito_text_persone',
        grid: 3,
      },
      {
        id: 'collection-graffito_text_nomi',
        type: 'collection',
        title: 'resource#collection_graffito_text_nomi',
        grid: 3,
      },
      {
        id: 'collection-graffito_text_ruoli',
        type: 'collection',
        title: 'resource#collection_graffito_text_ruoli',
        grid: 3,
      },
      {
        id: 'collection-graffito_text_luoghi',
        type: 'collection',
        title: 'resource#collection_graffito_text_luoghi',
        grid: 3,
      },
    ],
  },
} as ConfigMurucaResourceLayout;